import { Lang } from 'enums';

export const getTitle = (lang: Lang): string => {
  switch (lang) {
    case Lang.EN:
      return 'Sense-Bank - Request money';
    case Lang.UK:
      return 'Sense-Банк - Збір грошей';
  }
};
